<template>
  <div class="app-layout app-layout-backend">
    <nav-bar @handle-dark="toggleDarkMode" />
    <b-container :class="{ 'text-dark bg-light ': !isDarkMode, 'text-light bg-dark ': isDarkMode }" fluid>
      <slot />
      <footer-bar />
    </b-container>
  </div>
</template>

<script>
import { mapState , mapActions} from 'vuex';
import NavBar from '@/components/NavBar.vue';
import FooterBar from '@/components/FooterBar.vue';

export default {
  name: 'BackendLayout',
  components: {
    NavBar,
    FooterBar
  }, methods: {
    ...mapActions('darkMode', ['changeDarkMode']),
    toggleDarkMode() {
      this.changeDarkMode({ isDarkMode: !this.isDarkMode });

 
    }
  },  computed: {
    ...mapState('darkMode', ['isDarkMode'])
  }
};
</script>
